import request from "./request";
/**
 * 获取评论
 * @param pageId 专页id
 * @param pagePostId 帖子id
 */
export default async function getComments(params = {}) {
  return await request.get("/spin/dataSend/getComments", { params });
}
